import { render, staticRenderFns } from "./bookComment.vue?vue&type=template&id=7c0c415b&scoped=true"
import script from "./bookComment.vue?vue&type=script&lang=js"
export * from "./bookComment.vue?vue&type=script&lang=js"
import style0 from "./bookComment.vue?vue&type=style&index=0&id=7c0c415b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0c415b",
  null
  
)

export default component.exports